import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Immer auf der Haupt-Domain arbeiten (z. B. www → ohne www), sonst verwirft der Browser das Login-Cookie
const canonical = new URL(process.env.REACT_APP_BACKEND_URL);
if (window.location.hostname !== canonical.hostname && window.location.hostname !== "localhost") {
  window.location.replace(canonical.origin + window.location.pathname + window.location.search + window.location.hash);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
